import { post, get } from './client';

export interface GroupBookingRequest {
  type: 'school' | 'agent';
  orgName: string;
  picName: string;
  picEmail: string;
  picPhone: string;
  estimatedPax: number;
  ticketId: string;
  visitDate: string;
  paymentMethod?: string;
  notes?: string;
}

export interface PartnerRegisterRequest {
  fullName: string;
  email: string;
  password?: string;
  phone: string;
  socialMediaHandle?: string;
  socialMediaUrl?: string;
}

/**
 * Register a group booking inquiry
 */
export async function registerGroupBooking(data: GroupBookingRequest): Promise<any> {
  return await post('/public/partners/group', data);
}

/**
 * Register as an affiliate partner
 */
export async function registerPartner(data: PartnerRegisterRequest): Promise<any> {
  return await post('/public/partners/register', data);
}

/**
 * Get dashboard stats for current partner
 */
export async function getPartnerDashboard(): Promise<any> {
  return await get('/partner/dashboard');
}
